/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressDataDTO } from './address-data-dto';
import { SystemPropertiesDTO } from './system-properties-dto';
import { ContractLogDTO } from './contract-log-dto';
import { TenantGroupEnumDTO } from './tenant-group-enum-dto';
import { TenantTypeEnumDTO } from './tenant-type-enum-dto';
import { StatusLogDTO } from './status-log-dto';
import { TenantStatusEnumDTO } from './tenant-status-enum-dto';


/**
 * Tenant with status log information.
 */
export interface TenantWithStatusLogDTO { 
    /**
     * Represents the internal id of the tenant
     */
    id: string;
    /**
     * Human readable name of tenant organization
     */
    name?: string;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string;
    status?: TenantStatusEnumDTO;
    billingAddress?: AddressDataDTO;
    /**
     * reserved for future use
     */
    additionalData?: string;
    /**
     * The customer number from the billing system this tenant is linked to.
     */
    customerIdentifier?: string;
    /**
     * The tenant id of the parent tenant (the tenant from which this one was created).
     */
    parentTenantId?: string;
    tenantType?: TenantTypeEnumDTO;
    systemProperties?: SystemPropertiesDTO;
    vendorCode?: string;
    tenantGroup?: TenantGroupEnumDTO;
    fiscalContractLog?: Array<ContractLogDTO>;
    archivingContractLog?: Array<ContractLogDTO>;
    elsterContractLog?: Array<ContractLogDTO>;
    /**
     * Creation date
     */
    createdDate?: string;
    /**
     * Date of last change
     */
    lastModifiedDate?: string;
    /**
     * Created by
     */
    createdBy?: string;
    /**
     * Last modified by
     */
    lastModifiedBy?: string;
    statusLogs?: Array<StatusLogDTO>;
}

export class ClsTenantWithStatusLogDTO { 
    /**
     * Represents the internal id of the tenant
     */
    id: string = undefined;
    /**
     * Human readable name of tenant organization
     */
    name?: string = undefined;
    /**
     * Optional description of the entity
     */
    detailedDescription?: string = undefined;
    status?: TenantStatusEnumDTO = undefined;
    billingAddress?: AddressDataDTO = undefined;
    /**
     * reserved for future use
     */
    additionalData?: string = undefined;
    /**
     * The customer number from the billing system this tenant is linked to.
     */
    customerIdentifier?: string = undefined;
    /**
     * The tenant id of the parent tenant (the tenant from which this one was created).
     */
    parentTenantId?: string = undefined;
    tenantType?: TenantTypeEnumDTO = undefined;
    systemProperties?: SystemPropertiesDTO = undefined;
    vendorCode?: string = undefined;
    tenantGroup?: TenantGroupEnumDTO = undefined;
    fiscalContractLog?: Array<ContractLogDTO> = undefined;
    archivingContractLog?: Array<ContractLogDTO> = undefined;
    elsterContractLog?: Array<ContractLogDTO> = undefined;
    /**
     * Creation date
     */
    createdDate?: string = undefined;
    /**
     * Date of last change
     */
    lastModifiedDate?: string = undefined;
    /**
     * Created by
     */
    createdBy?: string = undefined;
    /**
     * Last modified by
     */
    lastModifiedBy?: string = undefined;
    statusLogs?: Array<StatusLogDTO> = undefined;
}



